import api from "./api";
const endpoint = "shared/Localisation";
export const LocalisationService = {
  async getAllRegions() {
    try {
      const result = await api.get(endpoint + "/regions_list");
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  
  async getAllDistricts() {
    try {
      const result = await api.get(endpoint + "/districts_list");
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  
  async getAllCommunes() {
    try {
      const result = await api.get(endpoint + "/communes_list");
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  
};
